import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

export const WHITESPACE_REGEX = /\s+/;

/**
 * Get initials from a display name. Returns '?' for empty/blank names.
 * Uses first letter of first word + first letter of last word for multi-word names,
 * or first two characters for single-word names.
 */
export const getInitials = (name: string): string => {
  const trimmed = name.trim();
  if (!trimmed) {
    return '?';
  }
  const parts = trimmed.split(WHITESPACE_REGEX);
  if (parts.length >= 2) {
    return `${parts.at(0)?.at(0) ?? ''}${parts.at(-1)?.at(0) ?? ''}`.toUpperCase();
  }
  return trimmed.slice(0, 2).toUpperCase();
};

// Text styles are CSS classes from the design system's text-styles.css, so tailwind-merge
// must learn that they set a font size. utils.test.ts checks this list against that file.
const TEXT_STYLE_CLASS_NAMES = [
  'type-display',
  'type-heading',
  'type-subheading',
  'type-title',
  'type-subtitle',
  'type-body',
  'type-caption',
  'type-kicker',
];
const twMerge = extendTailwindMerge({
  extend: { classGroups: { 'font-size': [...TEXT_STYLE_CLASS_NAMES] } },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
